import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './features/home/home.component';
import { MenuComponent } from './features/menu/menu.component';
import { ProductsComponent } from './features/products/products.component';
import { OurStoryComponent } from './features/our-story/our-story.component';
import { NewsStoriesComponent } from './features/news-stories/news-stories.component';
import { VisitUsComponent } from './features/visit-us/visit-us.component';
import { NewsStoriesDetailComponent } from './features/news-stories-detail/news-stories-detail.component';

const routes: Routes = [
  { path: "", redirectTo: "/home", pathMatch: "full" },
  { path: "home", component: HomeComponent },
  { path: "menu", component: MenuComponent },
  { path: "products", component: ProductsComponent },
  { path: "our-story", component: OurStoryComponent },
  { path: "news-stories", component: NewsStoriesComponent },
  { path: "news-stories/:slug", component: NewsStoriesDetailComponent },
  { path: "visit-us", component: VisitUsComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      scrollOffset: [0, 100] // Offsets scroll position for sticky header height
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }